import { render, staticRenderFns } from "./paytype-dialog.vue?vue&type=template&id=495c0972&scoped=true"
import script from "./paytype-dialog.vue?vue&type=script&lang=js"
export * from "./paytype-dialog.vue?vue&type=script&lang=js"
import style0 from "./paytype-dialog.vue?vue&type=style&index=0&id=495c0972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c0972",
  null
  
)

export default component.exports